var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-container"},[(_vm.storeBanners.length > 1)?_c('PromoBannerCarousel',{attrs:{"banners":[].concat( _vm.storeBanners )}}):_c('PromoBanner',{attrs:{"banners":[_vm.storeBanner]}}),_vm._v(" "),_c('StoreLayout')],1)}
var staticRenderFns = []

export { render, staticRenderFns }